<template>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">
        <div class="m-subheader ">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="m-subheader__title m-subheader__title--separator">
                        Donation
                    </h3>
                    <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
                        <li class="m-nav__item m-nav__item--home">
                            <router-link exact :to="{ name: 'home' }" class="m-nav__link m-nav__link--icon">
                                <i class="m-nav__link-icon la la-home"></i>
                            </router-link>
                        </li>
                        <li class="m-nav__separator">
                            -
                        </li>
                        <li class="m-nav__item">
                            <router-link exact :to="{ name : 'donation' }" class="m-nav__link"><span
                                    class="m-nav__link-text">Donation</span>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="m-content">

            <div class="kt-portlet kt-portlet--height-fluid">
                <div class="kt-portlet__head">

                    <div class="kt-portlet__head-toolbar">
                        <ul class="nav nav-pills nav-pills-sm nav-pills-label nav-pills-bold" role="tablist">
                            <li class="nav-item">
                                <router-link :to="{ name: 'donation'}" style="background-color: white;color:#6f727d" class="nav-link">
                                    Completed
                                </router-link>
                            </li>
                            <li class="nav-item">
                                <a href="#"  class="nav-link active ">Fail</a>

                            </li>


                        </ul>
                    </div>
                </div>

            </div>

            <div class="m-portlet m-portlet--mobile">
                <div class="m-portlet__head">
                    <div class="m-portlet__head-caption">
                        <div class="m-portlet__head-title">
                            <h3 class="m-portlet__head-text">
                                Donation Fail table
                                <small>
                                    List of all donation fail
                                </small>
                            </h3>
                        </div>
                    </div>
                    <div class="m-portlet__head-tools">
                    </div>
                </div>
                <div class="m-portlet__body">
                    <!--begin: Search Form -->
                    <!--<div class="m-form m-form&#45;&#45;label-align-right m&#45;&#45;margin-top-20 m&#45;&#45;margin-bottom-30">-->
                        <!--<div class="row align-items-center">-->
                            <!--<div class="col-xl-8 order-2 order-xl-1">-->
                                <!--<div class="form-group m-form__group row align-items-center">-->
                                    <!--<div class="col-md-4">-->
                                        <!--<div class="m-input-icon m-input-icon&#45;&#45;left">-->
                                            <!--<input type="text" class="form-control m-input m-input&#45;&#45;solid"-->
                                                   <!--v-model="search"-->
                                                   <!--placeholder="Search..." id="generalSearch">-->
                                            <!--<span class="m-input-icon__icon m-input-icon__icon&#45;&#45;left">-->
                                                <!--<span>-->
                                                    <!--<i class="la la-search"></i>-->
                                                <!--</span>-->
                                            <!--</span>-->
                                        <!--</div>-->
                                    <!--</div>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</div>-->
                    <!--</div>-->
                    <!--end: Search Form -->
                    <div class="table-responsive">
                    <table class="table table-inverse" v-if="donation.length > 0">
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Contacts</th>
                            <th>Address</th>
                            <th>Donate Amount</th>
                            <th>Gateway</th>

                            <th>Reason</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item,index in filteredDonation">
                            <td>{{index + 1}}</td>
                            <td>{{ item.name }}</td>
                            <td>
                                <span v-if="item.email">Email: {{ item.email }}</span> <br>
                                <span v-if="item.phone_number">Phone number: {{ item.phone_number }}</span> <br>
                            </td>
                            <td>
                                <span v-if="item.address">Address: {{ item.address }}, {{ item.city }}, {{ item.state }}</span>
                                <br>
                                <span v-if="item.zip">Zip code: {{ item.zip }}</span> <br>

                            </td>
                            <td>{{ item.amount }}</td>
                            <td>{{ item.type }}</td>


                            <td><span v-if="item.reason">{{ item.reason.name }}</span></td>

                        </tr>
                        </tbody>
                    </table>
                    </div>
                    <b-pagination v-if="total > 0 && total > pageSize" align="right" size="md" :total-rows="total"
                                  v-model="page" :per-page="pageSize">
                    </b-pagination>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import DonationApi from '../../api/donation';

    export default {
        components: {},
        name: "donation",
        data() {
            return {
                error: false,
                message: null,
                page: 1,
                total: 0,
                search: '',
                pageSize: 15,
                donationId: null,
                donation: [],
            }
        },
        computed: {
            filteredDonation: function () {
                return this.donation.filter((item) => {
                    if(item.name.match(this.search) || item.email.match(this.search) || item.amount.match(this.search)
            )
                {
                    return item;
                }
            })
                ;
            }
        },
        watch: {
            page(val) {
                this.getList()
            },
            pageSize(val) {
                this.getList()
            }
        },
        beforeMount() {
            this.getList()
        },
        methods: {
            getList() {
                DonationApi.getDonation(this, {
                    page: this.page,
                    pageSize: this.pageSize,
                    status:'processing'
                }, (context) => {}
            )
            },
            updatePageSize(val) {
                this.pageSize = parseInt(val);
            },
            clearId() {
                this.difficultyId = null;
                this.getList();
            }
        }
    }
</script>

<style scoped>

</style>